import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { API_URL, baseurl } from "../../_config";

const YclPlayerList = () => {
    const [players, setPlayers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchPlayers = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${baseurl}${API_URL.getAllPlayers}`);
            if (response?.data?.status === true) {
                setPlayers(response.data.data || []);
            } else {
                setPlayers([]);
            }
        } catch {
            toast.error("Failed to load YCL players");
            setPlayers([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchTeams = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (response?.data?.status === true) {
                setTeams((response.data.data || []).filter((team) => team?.type === "team"));
            }
        } catch {
            setTeams([]);
        }
    };

    useEffect(() => {
        fetchPlayers();
        fetchTeams();
    }, []);

    const isPlayerWithoutTeam = (player) => !player.teamId || Number(player.teamId) === 0 || !player.teamName;

    const handleAssignTeam = async (player, teamId) => {
        const selectedTeam = teams.find((team) => Number(team.id) === Number(teamId));

        setPlayers((prev) => prev.map((item) => (
            Number(item.playersId) === Number(player.playersId)
                ? {
                    ...item,
                    teamId: teamId || null,
                    teamName: selectedTeam?.teamName || null,
                }
                : item
        )));

        try {
            const response = await axios.post(`${baseurl}${API_URL.assignYclPlayerTeam}`, {
                playersId: player.playersId,
                teamId,
            });

            if (response.data?.status === true) {
                toast.success("Team assigned successfully");
                fetchPlayers();
            } else {
                toast.error(response.data?.message || "Team assign failed");
                fetchPlayers();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Please try again later.");
            fetchPlayers();
        }
    };

    const filteredPlayers = useMemo(() => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return players;

        return players.filter((player) => (
            String(player.playerName || "").toLowerCase().includes(term) ||
            String(player.playerRole || "").toLowerCase().includes(term) ||
            String(player.teamName || "").toLowerCase().includes(term)
        ));
    }, [players, searchTerm]);

    const columns = [
        {
            name: "S.No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Player",
            selector: (row) => row.playerName || "-",
            sortable: true,
            minWidth: "220px",
        },
        {
            name: "Role",
            selector: (row) => row.playerRole || "-",
            sortable: true,
            minWidth: "160px",
        },
        {
            name: "Team",
            selector: (row) => row.teamName || "Unassigned",
            cell: (row) => (
                isPlayerWithoutTeam(row) ? (
                    <select
                        className="form-control"
                        value={row.teamId || ""}
                        onChange={(event) => handleAssignTeam(row, event.target.value)}
                        style={{ minWidth: "210px" }}
                    >
                        <option value="">Select Team</option>
                        {teams.map((team) => (
                            <option key={team.id} value={team.id}>
                                {team.teamName}
                            </option>
                        ))}
                    </select>
                ) : (
                    row.teamName || "-"
                )
            ),
            sortable: true,
            minWidth: "260px",
        },
        {
            name: "Team ID",
            selector: (row) => row.teamId || "-",
            sortable: true,
            minWidth: "120px",
        },
        {
            name: "Player ID",
            selector: (row) => row.playersId || "-",
            sortable: true,
            minWidth: "120px",
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">YCL PlayerList</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredPlayers}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            </div>
        </Layout>
    );
};

export default YclPlayerList;
